import { c as _c } from "react/compiler-runtime";
import { Button, ButtonGroup, closeCurrentDialog, Form, FormButton, FormField, useTranslationContext } from 'platform/components';
import { VStack } from 'platform/foundation-tw';
import { z } from 'zod';
import { suffixTestId, TestIdProps } from 'shared/web';
import { Preset } from '../../../../types/Api';
type PartialPresetType = {
  title: string;
  description: string | null;
};
export type EditPresetDialogProps = TestIdProps & {
  presetToEdit?: Preset;
  onSubmit: (title: string, desc: string) => Promise<void>;
};
export function EditPresetDialog(props) {
  const $ = _c(15);
  const t = useTranslationContext();
  let t0;
  if ($[0] !== t) {
    t0 = z.object({
      title: z.string().trim().min(1, t("general.notifications.errorFieldRequired")),
      description: z.string().nullable()
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const PartialPresetTypeSchema = t0;
  let t1;
  if ($[2] !== props) {
    t1 = values => props.onSubmit(values.title, values.description ?? "").then(_temp);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  const t2 = props.presetToEdit?.title;
  const t3 = props.presetToEdit?.description;
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = {
      title: t2,
      description: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t) {
    t5 = control => <VStack spacing={4}><FormField control={control} isRequired={true} type="text" name="title" label={t("general.presets.presetName")} placeholder={t("general.presets.presetName")} data-testid={suffixTestId("presetName", props)} /><FormField control={control} type="textarea" name="description" label={t("general.presets.descriptionPlaceholder")} placeholder={t("general.presets.descriptionPlaceholder")} /><ButtonGroup align="right"><Button variant="secondary" title={t("general.actions.discard")} onClick={closeCurrentDialog} /><FormButton control={control} type="submit" title={t("general.actions.save")} data-testid={suffixTestId("submitButton", props)} /></ButtonGroup></VStack>;
    $[7] = props;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== PartialPresetTypeSchema || $[11] !== handleSubmit || $[12] !== t4 || $[13] !== t5) {
    t6 = <Form experimentalZodSchema={PartialPresetTypeSchema} onSubmit={handleSubmit} defaultValues={t4}>{t5}</Form>;
    $[10] = PartialPresetTypeSchema;
    $[11] = handleSubmit;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp() {
  return closeCurrentDialog();
}